import config from 'config';

export default (theme) => ({
  wrapper: {
    height: '100%',
    display: 'flex',
  },
  leftSide: {
    flexGrow: 1,
    minHeight: '100%',
    display: 'flex',
    position: 'relative',
  },
  leftSideContent: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '16%',
    marginLeft: '27vw',
    minWidth: 456,
    '@media (max-width: 1440px)': {
      marginLeft: '25vw',
    },
    '@media (max-width: 1024px)': {
      marginLeft: '20vw',
    },
    '@media (max-width: 698px)': {
      marginLeft: '17vw',
    },
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0,
      minWidth: 'auto',
      marginTop: '16%',
      padding: theme.spacing(0, 3),
    },
  },
  rightSide: {
    flexGrow: 1,
    width: '100%',
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  image: {
    position: 'absolute',
    top: theme.spacing(9.5),
    right: theme.spacing(9.5),
    width: '27vw',
    '@media (max-width: 1440px)': {
      top: theme.spacing(8.25),
      right: theme.spacing(8.25),
      width: '29vw',
    },
    '@media (max-width: 1024px)': {
      top: theme.spacing(5.75),
      right: theme.spacing(5.75),
      width: '31vw',
    },
    '@media (max-width: 698px)': {
      width: '37vw',
    },
  },
  contentWrapper: {
    minHeight: '100%',
    position: 'relative',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
  },
  alternativeContentWrapper: {
    position: 'static',
    width: 'auto',
  },
  loaderWrapper: {
    height: '100vh',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  transparentLoaderWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 100,
  },
  transparentLoaderBg: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: theme.palette.cardBackground,
    opacity: 0.6,
    zIndex: 100,
  },
  progressWrapper: {
    position: 'relative',
    zIndex: 101,
  },
  contentWrapperWithLoader: {
    display: 'none',
  },
  content: {
    flexGrow: 1,
    marginTop: '16%',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    maxWidth: 460,
    minWidth: 456,
    '@media (max-width: 1500px)': {
      padding: theme.spacing(0, 3),
    },
    [`@media (max-width: ${config.defaultPageWidth}px)`]: {
      width: `calc(100vw - ${theme.spacing(6)}px)`,
      minWidth: 'auto',
    },
    [`@media (max-width: ${config.minDeviceWidth}px)`]: {
      minWidth: 320,
    },
  },
  alternativeContent: {
    marginTop: 0,
    '@media (max-width: 1500px)': {
      padding: 0,
    },
  },
  movedToTop: {
    marginTop: '16%',
  },
  logoWrapper: {
    marginBottom: 50,
  },
  version: {
    position: 'absolute',
    bottom: 15,
    left: 15,
    fontSize: 12,
    lineHeight: 1.4,

    '@media (max-width: 768px)': {
      bottom: 52,
      left: 24,
    },
  },
  errorSnackbar: {
    backgroundColor: theme.palette.error.tertiary,
  },

});
